import React, { useCallback, useMemo } from 'react';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import FormConstructor from '@/common/containers/FormConstructor/index';
import { useSectionsQuestions } from '@/common/hooks/index';
import Loader from '@/common/components/Loader/index';
import { useQuestionListQuery } from '@/entities/question';

const AssetTasks = ({ onSubmit, ...props }) => {
  const decedentId = useCurrentDecedentId();
  const questionListQuery = useQuestionListQuery('asset', decedentId);
  const payload = useMemo(() => {
    if (!questionListQuery.data) {
      return {};
    }

    const { list, answers } = questionListQuery.data;

    return {
      questions: list,
      answers,
    };
  }, [questionListQuery.data]);
  const formKey = String(questionListQuery.dataUpdatedAt || '1');

  const { questions } = useSectionsQuestions(payload.questions);

  const handleSubmit = useCallback(
    async (form) => {
      await onSubmit(form);
      await questionListQuery.refetch();
    },
    [onSubmit, questionListQuery]
  );

  return questions.length ? (
    <FormConstructor
      {...props}
      onSubmit={handleSubmit}
      questions={questions}
      answers={payload.answers}
      key={formKey}
    />
  ) : (
    <Loader />
  );
};

export default AssetTasks;
